import { Component, computed, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import {
    CeIconComponent,
    CeLevelMenuBaseComponent,
    CeNameDisplayComponent,
    CeOverlayService,
    CePopoverImports,
    CePopoverTriggerForDirective,
    CeSpinningLoaderComponent,
} from '@kempower-nx-workspace/shared/kp-design-system';
import { OrganizationSwitchComponent } from '@kempower-nx-workspace/organization-switcher';

@Component({
    selector: 'ce-core-side-nav-org-switch',
    imports: [CommonModule, RouterLink, RouterLinkActive, CeNameDisplayComponent, CeLevelMenuBaseComponent, CeIconComponent, OrganizationSwitchComponent, CeSpinningLoaderComponent, CePopoverImports],
    providers: [CeOverlayService],
    templateUrl: './side-nav-org-switch.component.html',
})
export class CoreSideNavOrgSwitchComponent {
    readonly #router = inject(Router);

    popoverProfileRef!: CePopoverTriggerForDirective;
    popoverOrgSwitchRef!: CePopoverTriggerForDirective;
    orgName = input<string>('');
    isLoading = signal(true);

    readonly #url = toSignal(
        this.#router.events.pipe(
            filter((e): e is NavigationEnd => e instanceof NavigationEnd),
            map((e) => e.urlAfterRedirects),
            startWith(this.#router.url)
        ),
        { initialValue: this.#router.url }
    );

    readonly isOrganizationSettingsActive = computed(() => this.#url().startsWith('/organization-settings'));

    orgSwitchRef($event: CePopoverTriggerForDirective): void {
        this.popoverOrgSwitchRef = $event;
        if (this.popoverProfileRef) {
            this.popoverProfileRef.hidePopup();
        }
    }

    orgSwitchEvent(event: string): void {
        if (event === 'loading' || event === 'close') {
            this.popoverOrgSwitchRef?.hidePopup();
        }

        this.isLoading.set(event === 'loading');
    }
}
